import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AngularResizeEventModule } from 'angular-resize-event';
import { MarkdownModule } from 'ngx-markdown';
import { SwiperModule } from 'swiper/angular';

import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ImageSliderDialogComponent } from './components/image-slider/image-slider-dialog/image-slider-dialog.component';
import {
  SliderDialogImageZoomedComponent
} from './components/image-slider/image-slider-dialog/slider-dialog-image/slider-dialog-image-zoomed/slider-dialog-image-zoomed.component';
import { SliderDialogImageComponent } from './components/image-slider/image-slider-dialog/slider-dialog-image/slider-dialog-image.component';
import { ImageSliderComponent } from './components/image-slider/image-slider.component';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { LoaderComponent } from './components/loader/loader.component';
import { MarkdownTextComponent } from './components/markdown-text/markdown-text.component';
import { MediaItemListComponent } from './components/media-item-list/media-item-list.component';
import { MediaItemVideoComponent } from './components/media-item-video/media-item-video.component';
import { NumberCounterComponent } from './components/number-counter/number-counter.component';
import { SvgGraphComponent } from './components/svg-graph/svg-graph.component';

import { DebounceClickDirective } from './directives/debounced-click.directive';
import { HoverStateDirective } from './directives/hover-state.directive';
import { ImageOrientationDirective } from './directives/image-orientation.directive';
import { ParseUrlDirective } from './directives/parse-url.directive';
import { PlayAudioDirective } from './directives/play-audio.directive';
import { RequestDisabledButtonDirective } from './directives/request-disabled-button.directive';
import { StickyElementDirective } from './directives/sticky-element.directive';
import { CustomUtilModule } from './modules/custom-utils/custom-util-module';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import {FileDownloadDirective} from "./directives/file-download.directive";

@NgModule({
  declarations: [
    StickyElementDirective,
    InfoDialogComponent,
    ConfirmDialogComponent,
    LoaderComponent,
    ImageOrientationDirective,
    PlayAudioDirective,
    DebounceClickDirective,
    RequestDisabledButtonDirective,
    MediaItemVideoComponent,
    MediaItemListComponent,
    NumberCounterComponent,
    ImageSliderComponent,
    ImageSliderDialogComponent,
    SliderDialogImageComponent,
    SliderDialogImageZoomedComponent,
    ParseUrlDirective,
    SvgGraphComponent,
    MarkdownTextComponent,
    FileDownloadDirective,
    HoverStateDirective,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    CustomUtilModule,
    SwiperModule,
    MarkdownModule,
    AngularResizeEventModule,
    MatLegacyButtonModule,
  ],
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        hasBackdrop: true,
        position: {
          top: '100px',
        },
      },
    },
  ],
  exports: [
    StickyElementDirective,
    TranslateModule,
    LoaderComponent,
    ImageOrientationDirective,
    DebounceClickDirective,
    RequestDisabledButtonDirective,
    PlayAudioDirective,
    NumberCounterComponent,
    MediaItemVideoComponent,
    MediaItemListComponent,
    ImageSliderComponent,
    ImageSliderDialogComponent,
    SliderDialogImageComponent,
    SliderDialogImageZoomedComponent,
    ParseUrlDirective,
    SvgGraphComponent,
    MarkdownTextComponent,
    HoverStateDirective,
    FileDownloadDirective,
  ],
})
export class SharedModule {
}
